
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    'core-app-bar': () => import('./../../components/core/AppBar.vue'),
    'core-drawer': () => import('./../../components/core/Drawer.vue'),
    'core-view': () => import('./../../components/core/View.vue'),
  },
})
export default class DashboardIndex extends Vue {}
